<script setup lang="ts">
import { NXGRetailSsbtHeader } from '@nsftx/seven-nxg-retail-vue-sdk/ui'
import STHeaderLeftControls from './STHeaderLeftControls.vue'
import STHeaderRightControls from './STHeaderRightControls.vue'
</script>

<template>
  <NXGRetailSsbtHeader class="st-header">
    <template #leading>
      <STHeaderLeftControls>
        <template #navigation-menu>
          <slot name="navigation-menu" />
        </template>
      </STHeaderLeftControls>
    </template>
    <template #trailing>
      <STHeaderRightControls />
    </template>
  </NXGRetailSsbtHeader>
</template>

<style lang="scss" scoped>
.st-header {
  /* App hook for layout overrides when needed. */
}
</style>
